import React, { useState } from 'react';
import './Modal.css';

interface SupportModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SupportModal: React.FC<SupportModalProps> = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    issueType: '',
    description: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleWhatsAppContact = () => {
    const { name, email, issueType, description } = formData;
    
    // Create WhatsApp message
    const message = `Hello, I need support with NuruSubs.

Name: ${name || 'Not provided'}
Email: ${email || 'Not provided'}
Issue Type: ${issueType || 'Not specified'}

Description:
${description || 'No description provided'}`;

    const whatsappNumber = '255765210248';
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    
    window.open(whatsappUrl, '_blank');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>&times;</button>
        
        <div className="modal-header">
          <span className="support-icon">💬</span>
          <h2>Help & Support</h2>
        </div>

        <div className="modal-body">
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="your.email@example.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="issueType">Type of Issue</label>
            <select
              id="issueType"
              name="issueType"
              value={formData.issueType}
              onChange={handleChange}
            >
              <option value="">Select an issue</option>
              <option value="Technical Issue">Technical Issue</option>
              <option value="Billing Question">Billing Question</option>
              <option value="Feature Request">Feature Request</option>
              <option value="Account Issue">Account Issue</option>
              <option value="Translation Quality">Translation Quality</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Please describe your issue in detail..."
              rows={5}
            />
          </div>

          <button 
            className="support-whatsapp-btn"
            onClick={handleWhatsAppContact}
          >
            <span className="whatsapp-icon">📱</span>
            Contact Support via WhatsApp
          </button>

          <p className="support-note">
            Our support team will respond to your message as soon as possible during business hours.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SupportModal;
